import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './views/layout/header/header.component';
import { FooterComponent } from './views/layout/footer/footer.component';
import { HomeComponent } from './views/pages/home/home.component';
import { AboutComponent } from './views/pages/about/about.component';
import { NotfoundComponent } from './views/pages/notfound/notfound.component';
import { ContactComponent } from './views/pages/contact/contact.component';
import { MicrositeComponent } from './views/dept/microsite/microsite.component';
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DegreesComponent } from './views/dept/degrees/degrees.component';
import { DeptHeaderComponent } from './views/dept/dept-header/dept-header.component';
import { DegreeDetailsComponent } from './views/dept/degree-details/degree-details.component';
import { AllinfoComponent } from './views/pages/information/allinfo/allinfo.component';
import { InfoComponent } from './views/pages/information/info/info.component';
import { AllnewsComponent } from './views/pages/information/allnews/allnews.component';
import { AllotherComponent } from './views/pages/information/allother/allother.component';
import { DeanmsgComponent } from './views/pages/deanmsg/deanmsg.component';
import { FaqComponent } from './views/pages/faq/faq.component';
import { AllstaffComponent } from './views/pages/staff/allstaff/allstaff.component';
import { StaffmemberComponent } from './views/pages/staff/staffmember/staffmember.component';
import { DeptstaffComponent } from './views/pages/staff/deptstaff/deptstaff.component';
import { ResearchComponent } from './views/pages/research/research.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CounsellingComponent } from './views/pages/counselling/counselling.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { HisArchiStuSocietyComponent } from './views/dept/society/his-archi-stu-society/his-archi-stu-society.component';
import { PaliBuddistAssocComponent } from './views/dept/society/pali-buddist-assoc/pali-buddist-assoc.component';
import { GeoEnvSciSocietyComponent } from './views/dept/society/geo-env-sci-society/geo-env-sci-society.component';
import { PublicPolicySocietyComponent } from './views/dept/society/public-policy-society/public-policy-society.component';
import { EcoSocialStuSocietyComponent } from './views/dept/society/eco-social-stu-society/eco-social-stu-society.component';
import { SocioAssoComponent } from './views/dept/society/socio-asso/socio-asso.component';
import { SiteSearchComponent } from './views/pages/site-search/site-search.component';
import { InternaltionlStuComponent } from './views/pages/internaltionl-stu/internaltionl-stu.component';
import { YoutubePipe } from './pipe/youtube.pipe';
import { NgImageSliderModule } from 'ng-image-slider';
import { ResearchCentreComponent } from './views/pages/research-centre/research-centre.component';
import { ResearchCommitteeComponent } from './views/pages/research-committee/research-committee.component';
import { EthicsReviewCommitteeComponent } from './views/pages/ethics-review-committee/ethics-review-committee.component';
import { ParallaxDirective } from './parallax.directive';
import { FullCalendarModule } from '@fullcalendar/angular'; // Import FullCalendarModule first
import { CalendarComponent } from './views/pages/lhms/calendar/calendar.component';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridWeek from '@fullcalendar/timegrid';
import listWeek from '@fullcalendar/list';
import { ContentAnimateDirective } from '../app/core/content-animate/content-animate.directive';
import {DailyweatherComponent} from "./views/pages/dailyweather/dailyweather.component";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutComponent,
    NotfoundComponent,
    ContactComponent,
    MicrositeComponent,
    DegreesComponent,
    DeptHeaderComponent,
    DegreeDetailsComponent,
    AllinfoComponent,
    InfoComponent,
    AllnewsComponent,
    AllotherComponent,
    DeanmsgComponent,
    FaqComponent,
    AllstaffComponent,
    StaffmemberComponent,
    DeptstaffComponent,
    ResearchComponent,
    CounsellingComponent,
    HisArchiStuSocietyComponent,
    PaliBuddistAssocComponent,
    GeoEnvSciSocietyComponent,
    PublicPolicySocietyComponent,
    EcoSocialStuSocietyComponent,
    SocioAssoComponent,
    SiteSearchComponent,
    InternaltionlStuComponent,
    YoutubePipe,
    ResearchCentreComponent,
    DailyweatherComponent,
    ResearchCommitteeComponent,
    EthicsReviewCommitteeComponent,
    ParallaxDirective,
    CalendarComponent,
    ContentAnimateDirective
  ],
  imports: [
    FullCalendarModule,
    CommonModule,
    HttpClientModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FormsModule,
    NgbCollapseModule,
    ReactiveFormsModule,
    NgImageSliderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgbModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    FullCalendarModule.registerPlugins([dayGridPlugin, timeGridWeek, listWeek]); // Register dayGrid plugin
  }
}
